import React from 'react';
import styles from './PageHeader.module.css';

/**
 * PageHeader
 * Props:
 * - title: string | ReactNode
 * - subtext?: string | ReactNode
 * - align?: 'left' | 'center' | 'right' (default: 'left')
 * - size?: 'sm' | 'md' | 'lg' (default: 'md')
 * - className?: string
 * - style?: React.CSSProperties
 */
export function PageHeader({
  title,
  subtext,
  align = 'left',
  size = 'md',
  className,
  style,
  ...rest
}) {
  const classes = [styles.header];
  const alignMap = { left: styles.left, center: styles.center, right: styles.right };
  const alignClass = alignMap[align] || styles.left;
  classes.push(alignClass);

  const sizeMap = { sm: styles.sm, md: styles.md, lg: styles.lg };
  classes.push(sizeMap[size] || styles.md);
  if (className) classes.push(className);

  return (
    <header className={classes.join(' ')} style={style} {...rest}>
      {title && <h1 className={styles.title}>{title}</h1>}
      {subtext && <p className={styles.subtext}>{subtext}</p>}
    </header>
  );
}
